<template>
  <v-container fluid full-height grid-list-md>
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-layout row wrap>
        <v-flex xs6>
          <div class="text-xs-left">
            <v-breadcrumbs :items="breadcrumbs" divider=">">
              <template slot="item" slot-scope="props">
                <router-link
                  :to="'/'+props.item.to"
                  :disabled="props.item.disabled"
                  v-bind:class="{ 'v-breadcrumbs__item v-breadcrumbs__item--disabled': props.item.disabled }"
                >{{props.item.text}}</router-link>
              </template>
            </v-breadcrumbs>
          </div>
        </v-flex>
        <v-flex xs6>
          <div class="text-xs-right">
            <v-btn outline color="primary" @click="goBack">
              Go Back
              <v-icon right>arrow_back</v-icon>
            </v-btn>
          </div>
        </v-flex>
        <v-flex>
          <v-card>
            <v-layout row wrap class="pa-3">
              <v-flex sm12 v-if="responseError">
                <span class="red--text">* {{responseError}}</span>
              </v-flex>
              <v-flex sm12>
                <v-menu
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="status != 'DRAFT'"
                >
                  <v-text-field
                    slot="activator"
                    label="IssueDate"
                    type="text"
                    prepend-icon="event"
                    v-model="issueDate"
                    readonly
                    :rules="rules.issueDateRules"
                  ></v-text-field>
                  <v-date-picker v-model="issueDate" :rules="rules.issueDateRules"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm12>
                <v-autocomplete
                  v-model="stockIn.warehouseName"
                  :items="warehouseList"
                  color="blue-grey lighten-2"
                  label="Choose Warehouse..."
                  item-text="name"
                  menu-props="auto"
                  item-value="name"
                  :readonly="status != 'DRAFT' || user.role.roleName == 'WAREHOUSE_MANAGER'"
                  :rules="rules.warehouseRules"
                ></v-autocomplete>
              </v-flex>
              <v-flex sm12>
                <v-layout>
                  <v-flex sm10>
                    <v-text-field
                      name="poNo"
                      label="Po No"
                      v-model="stockIn.poNo"
                      type="text"
                      :readonly="status != 'DRAFT'"
                      :rules="rules.poNoRules"
                    ></v-text-field>
                  </v-flex>
                  <v-flex sm2>
                    <v-btn
                      outline
                      color="warning"
                      :disabled="status != 'DRAFT'"
                      @click="showPurchaseOrder"
                    >
                      Search
                      <v-icon dark>search</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex sm12>
                <v-autocomplete
                  :readonly="status != 'DRAFT'"
                  v-model="stockIn.status"
                  :items="statusList"
                  :hide-no-data="true"
                  color="blue-grey lighten-2"
                  label="Choose Status..."
                  item-text="label"
                  item-value="value"
                  menu-props="auto"
                  :rules="rules.statusRules"
                ></v-autocomplete>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="description"
                  label="Description"
                  v-model="stockIn.description"
                  type="text"
                  :readonly="status != 'DRAFT'"
                  :rules="rules.descriptionRuless"
                ></v-text-field>
              </v-flex>
              <v-flex sm12 v-if="stockIn.id">
                <v-menu
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="true"
                >
                  <v-text-field
                    slot="activator"
                    label="Created Date"
                    type="text"
                    prepend-icon="event"
                    v-model="createdDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="createdDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm12 v-if="stockIn.id">
                <v-text-field
                  name="createdBy"
                  label="Created By"
                  v-model="stockIn.createdBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm12 v-if="stockIn.id">
                <v-menu
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="true"
                >
                  <v-text-field
                    slot="activator"
                    label="Updated Date"
                    type="text"
                    prepend-icon="event"
                    v-model="updatedDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="updatedDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm12 v-if="stockIn.id">
                <v-text-field
                  name="updateBy"
                  label="Updated By"
                  v-model="stockIn.updatedBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex>
                <v-layout row wrap>
                  <v-btn color="success" @click="addStockInItem()" :disabled="status != 'DRAFT'">
                    Add StockIn Item
                    <v-icon right>add</v-icon>
                  </v-btn>
                  <!-- Barcode input -->
                  <v-flex xs7 ml-4>
                    <v-text-field
                      name="scanBarcode"
                      label="Scan barcode....."
                      v-model="scanBarcode"
                      type="text"
                      v-on:keyup.enter="trigger(scanBarcode)"
                      autofocus
                      prepend-icon="filter_center_focus"
                    ></v-text-field>
                  </v-flex>
                  <!-- Barcode input -->
                </v-layout>
                <v-layout row wrap class="light--text">
                  <v-flex xs2>Code</v-flex>
                  <v-flex xs2>Product</v-flex>
                  <v-flex xs1>Unit</v-flex>
                  <v-flex xs1>Qty</v-flex>
                  <v-flex xs2>Remark</v-flex>
                  <v-flex xs1>Action</v-flex>
                </v-layout>
                <v-layout
                  row
                  wrap
                  v-for="(stockInItem, index) in stockIn.stockInItems"
                  :key="index"
                >
                  <v-flex xs2>
                    <v-text-field
                      v-if="status != 'DRAFT'"
                      placeholder="Select the code"
                      v-model="stockInItem.productCode"
                      readonly
                      :rules="rules.codeRules"
                    ></v-text-field>
                    <v-text-field
                      v-else
                      placeholder="Select the code"
                      v-model="stockInItem.productCode"
                      @click="showProducts(), selectedIndex = index"
                      :rules="rules.codeRules"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs2>
                    <v-text-field
                      v-model="stockInItem.productName"
                      :loading="showAutocompleteLoading"
                      label="Product"
                      :readonly="true"
                      :rules="rules.nameRules"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs1>
                    <v-autocomplete
                      v-model="stockInItem.factorUnitName"
                      :loading="showAutocompleteLoading"
                      :hide-no-data="true"
                      :items="stockInItem.productUnits"
                      color="blue-grey lighten-2"
                      item-value="factorUnitName"
                      item-text="factorUnitName"
                      menu-props="auto"
                      label="Select"
                      :readonly="status != 'DRAFT'"
                      @change="option => initPrice(option,index)"
                      :rules="rules.unitRules"
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex xs1>
                    <v-text-field
                      v-model="stockInItem.qty"
                      type="number"
                      min="0"
                      oninput="this.value = Math.abs(this.value)"
                      :rules="rules.qtyRules"
                      :readonly="status != 'DRAFT'"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs2>
                    <v-text-field
                      v-model="stockInItem.remark"
                      type="text"
                      :rules="rules.remarkRules"
                      :readonly="status != 'DRAFT'"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs1>
                    <v-btn
                      icon
                      @click="removeStockInItem(index, stockInItem.id)"
                      :disabled=" status != 'DRAFT' || index == 0"
                    >
                      <v-icon>cancel</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex sm12>
                <div class="text-xs-center">
                  <v-btn color="error" @click="clear" :disabled="stockIn.id?true:false">
                    Reset
                    <v-icon right>clear</v-icon>
                  </v-btn>
                  <v-btn
                    color="primary"
                    :loading="saveLoading"
                    :readonly="!valid"
                    @click="onSave"
                    :disabled="btnDisabled"
                  >
                    Save
                    <v-icon right>save</v-icon>
                  </v-btn>
                </div>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </v-form>
    <!-- Purchase order list dialog-->
    <v-dialog v-model="showPurchaseOrderListDialog" scrollable max-width="1000px">
      <v-card>
        <v-card-title>
          <v-layout row wrap class="pa-3">
            <v-flex sm4>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="purchaseOrderQueryParams.fromIssueDate"
                  label="From Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="purchaseOrderQueryParams.fromIssueDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm4>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="purchaseOrderQueryParams.toIssueDate"
                  label="To Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="purchaseOrderQueryParams.toIssueDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm4>
              <v-text-field
                name="issueNo"
                label="Issue No"
                type="text"
                v-model="purchaseOrderQueryParams.issueNo"
              ></v-text-field>
            </v-flex>
            <v-flex sm4>
              <v-autocomplete
                :items="currencyList"
                :hide-no-data="true"
                color="blue-grey lighten-2"
                label="Choose Currency..."
                item-value="id"
                item-text="code"
                menu-props="auto"
                v-model="purchaseOrderQueryParams.currencyId"
              ></v-autocomplete>
            </v-flex>
            <v-flex sm4>
              <v-autocomplete
                :items="purchaseOrderWarehouseList"
                :hide-no-data="true"
                color="blue-grey lighten-2"
                label="Choose Warehouse..."
                item-value="id"
                item-text="name"
                menu-props="auto"
                v-model="purchaseOrderQueryParams.warehouseId"
              ></v-autocomplete>
            </v-flex>
            <v-flex sm4>
              <v-btn outline color="primary" @click="purchaseOrderOnSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-card-text>
          <v-flex xs12 class="mt-1">
            <v-card>
              <v-data-table
                :must-sort="true"
                :headers="purchaseOrderHeaders"
                :items="purchaseOrderList"
                class="elevation-1"
                :loading="showListLoading"
                :total-items="purchaseOrderTotalRows"
                :rows-per-page-items="purchaseOrderRowsPerPageItems"
                :pagination.sync="purchaseOrderPagination"
              >
                <template slot="items" slot-scope="props">
                  <td>{{ props.item.issueDateInMilliSeconds | format-ms-date }}</td>
                  <td
                    @click="prepareStockInItems(props.item), showPurchaseOrderListDialog = !showPurchaseOrderListDialog"
                  >
                    <a>{{ props.item.issueNo }}</a>
                  </td>
                  <td>{{ props.item.companyName }}</td>
                  <td>{{ props.item.currencyCode }}</td>
                  <td>{{ props.item.warehouseName }}</td>
                  <td>{{ props.item.status }}</td>
                  <td>{{ props.item.description }}</td>
                  <td>{{ props.item.updatedDateInMilliSeconds | format-ms-date-time }}</td>
                  <td>{{ props.item.updatedBy }}</td>
                </template>
              </v-data-table>
            </v-card>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Product list dialog -->
    <v-dialog v-model="showProductListDialog" scrollable max-width="1000px">
      <v-card>
        <v-card-title>
          <!-- Search Section -->
          <v-layout wrap>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="code"
                label="Code"
                type="text"
                class="mr-1"
                v-model="queryParams.code"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="name"
                label="Name"
                type="text"
                class="mr-1"
                v-model="queryParams.name"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="brandName"
                label="Brand"
                type="text"
                class="mr-1"
                v-model="queryParams.brandName"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="categoryName"
                label="Category"
                type="text"
                class="mr-1"
                v-model="queryParams.categoryName"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="productGroupName"
                label="Product Group"
                type="text"
                class="mr-1"
                v-model="queryParams.productGroupName"
              ></v-text-field>
            </v-flex>
            <v-flex sm2>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <!-- Product List Section -->
          <v-flex xs12 class="mt-1">
            <v-card>
              <v-data-table
                :headers="headers"
                :items="productList"
                class="elevation-1"
                :loading="showListLoading"
                :total-items="totalRows"
                :rows-per-page-items="rowsPerPageItems"
                :pagination.sync="pagination"
                :must-sort="true"
              >
                <template slot="items" slot-scope="props">
                  <td
                    @click="setProduct(props.item.code, selectedIndex), showProductListDialog = !showProductListDialog"
                  >
                    <a>{{ props.item.code }}</a>
                  </td>
                  <td>{{ props.item.name }}</td>
                  <td>{{ props.item.brand.name }}</td>
                  <td>{{ props.item.category.name }}</td>
                  <td v-if="props.item.productGroup">{{ props.item.productGroup.name }}</td>
                  <td v-else></td>
                  <td>{{ props.item.description }}</td>
                </template>
              </v-data-table>
            </v-card>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { warehouseService } from "../../services/warehouse-service";
import { productService } from "../../services/product-service";
import { stockInService } from "../../services/stockin-service";
import { commonService } from "../../services/common-service";
import { currencyService } from "../../services/currency-service";
import { purchaseOrderService } from "../../services/purchase-order-service";
import VSwitch from "vuetify/lib/components/VSwitch/VSwitch";
import { StockInItem } from "../../models/model";
import { StockIn } from "../../models/model";
import { ProductUnit } from "../../models/model";
import { StockInFormRules } from "../../helpers/validation-rules";

export default {
  name: "StockInDetail",
  components: { VSwitch },
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    valid: true,
    breadcrumbs: [
      {
        text: "StockIn",
        disabled: false,
        to: "stockins"
      },
      {
        text: "StockIn Detail",
        disabled: true
      }
    ],
    createdDate: "",
    updatedDate: "",
    status: "DRAFT",
    issueDate: "",
    stockIn: new StockIn(),
    oldStockIn: new StockIn(),
    stockInItem: new StockInItem(),
    rules: new StockInFormRules(),
    responseError: "",
    showAutocompleteLoading: false,
    saveLoading: false,
    warehouseList: [],
    productUnitList: [],
    productList: [],
    scanBarcode: "",
    btnDisabled: false,
    statusList: [
      { label: "DRAFT", value: "DRAFT" },
      { label: "FINISHED", value: "FINISHED" },
      { label: "CANCEL", value: "CANCEL" }
    ],
    showProductListDialog: false,
    headers: [
      { text: "Code", value: "code" },
      { text: "Name", align: "left", value: "name" },
      { text: "Brand", value: "brand.name" },
      { text: "Category", value: "category.name" },
      { text: "Product Group", value: "productGroup.name" },
      { text: "Description", value: "description" }
    ],
    rowsPerPageItems: [10, 50, 100],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 10,
      sortBy: "code",
      totalItems: 0
    },
    totalRows: 0,
    queryParams: {
      name: "",
      code: "",
      status: "ACTIVE",
      brandName: "",
      categoryName: "",
      productGroupName: ""
    },
    search: null,
    code: "",
    showListLoading: false,
    selectedIndex: 0,

    purchaseOrderHeaders: [
      { text: "Issue Date", align: "left", value: "issueDate" },
      { text: "Issue No", value: "issueNo" },
      { text: "Supplier", value: "supplier.companyName" },
      { text: "Currency", value: "currency.code" },
      { text: "Warehouse", value: "warehouse.name" },
      { text: "Status", value: "status" },
      { text: "Description", value: "description" },
      { text: "Updated Date", value: "updatedDate" },
      { text: "Updated By", value: "updatedBy" },
      { text: "Action", value: "action", sortable: false }
    ],
    purchaseOrderRowsPerPageItems: [25, 50, 100],
    purchaseOrderPagination: {
      descending: true,
      page: 1,
      rowsPerPage: 50,
      sortBy: "updatedDate",
      totalItems: 0
    },
    purchaseOrderList: [],
    supplierList: [],
    purchaseOrderWarehouseList: [],
    currencyList: [],
    purchaseOrderTotalRows: 0,
    purchaseOrderQueryParams: {
      fromIssueDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      toIssueDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      issueNo: "",
      status: "",
      supplierId: "",
      currencyId: "",
      warehouseId: "",
      restrictAlreadyRegisteredPoNoFlag: true
    },
    showPurchaseOrderListDialog: false
  }),

  watch: {
    pagination: {
      handler() {
        this.getProductList();
      },
      deep: true
    },
    purchaseOrderPagination: {
      handler() {
        this.getPurchaseOrderList();
      },
      deep: true
    }
  },

  created() {
    this.getWarehouseList();
    this.getCurrencyList();
    const id = this.$route.params.id;
    if (id == "new") {
      if (this.user.role.roleName == "WAREHOUSE_MANAGER") {
        this.stockIn.warehouseName = this.user.warehouseName;
      }
      // new stockin
      this.issueDate = commonService.formatDate(
        new Date().toISOString().substr(0, 10),
        "YYYY-MM-DD"
      );
      this.addStockInItem();
    } else {
      this.getStockInDetail(id);
    }
  },

  methods: {
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.getProductList();
    },
    purchaseOrderOnSearch() {
      this.purchaseOrderQueryParams.page = this.purchaseOrderPagination.page;
      this.purchaseOrderQueryParams.rowsPerPage = this.purchaseOrderPagination.rowsPerPage;
      this.getPurchaseOrderList();
    },

    productNameChange: function(productName) {
      productService
        .productsByName(productName)
        .then(res => {
          let tempList = res.data;
          for (let temp of tempList) {
            for (let list of temp.productUnits) {
              this.productUnit = new ProductUnit();
              this.productUnit.unitName = list.unitName;
              this.productUnit.factor = list.factor;
              this.productUnitList.push(this.productUnit);
            }
          }
        })
        .catch(err => {
          console.log(err);
        });
    },

    getWarehouseList() {
      warehouseService
        .getAllWarehouse("ACTIVE")
        .then(res => {
          let tempList = res.data;
          for (let temp of tempList) {
            this.warehouseList.push(temp);
          }
          this.purchaseOrderWarehouseList = tempList;
          let findAll = {
            id: "",
            name: "----All----"
          };
          this.purchaseOrderWarehouseList.splice(
            0,
            0,
            JSON.parse(JSON.stringify(findAll))
          );
        })
        .catch(err => {
          console.log(err);
        });
    },
    getCurrencyList() {
      currencyService
        .getAllCurrency()
        .then(res => {
          this.currencyList = res.data;
          let findAll = {
            id: "",
            code: "----All----"
          };
          this.currencyList.splice(0, 0, JSON.parse(JSON.stringify(findAll)));
        })
        .catch(err => {
          console.log(err);
        });
    },
    goBack() {
      this.$router.push("/stockins");
    },

    addStockInItem() {
      // deep copy
      stockInItem = new StockInItem();
      let stockInItem = JSON.parse(JSON.stringify(this.stockInItem));

      this.stockIn.stockInItems.push(stockInItem);
    },
    trigger(barcode) {
      if (barcode) {
        this.getProductUnitByBarcode(barcode);
      }
    },
    getProductUnitByBarcode(barcode) {
      productService
        .getProductUnitByBarcode(barcode)
        .then(res => {
          let productUnit = res.data;
          
          if (this.stockIn.stockInItems[0].productCode == null) {
            this.stockIn.stockInItems[0].productUnits = [productUnit];
            this.stockIn.stockInItems[0].productCode = productUnit.product.code;
            this.stockIn.stockInItems[0].productName = productUnit.product.name;
            this.stockIn.stockInItems[0].unitCost = productUnit.unitCost;
            this.stockIn.stockInItems[0].sellingPrice =
              productUnit.sellingPrice;
            this.stockIn.stockInItems[0].factorUnitName =
              productUnit.factorUnitName;
            this.stockIn.stockInItems[0].qty += 1;
          } else {
            let flag = false;
            let point = "";
            for (
              let index = 0;
              index < this.stockIn.stockInItems.length;
              index++
            ) {
              if (
                this.stockIn.stockInItems[index].productCode ==
                  productUnit.product.code &&
                this.stockIn.stockInItems[index].factorUnitName ==
                  productUnit.factorUnitName
              ) {
                flag = true;
                point = index;
                break;
              }
            }
            // deep copy
            if (flag) {
              this.stockIn.stockInItems[point].qty += 1;
            } else {
              this.stockInItem = new StockInItem();
              let _stockInItem = JSON.parse(JSON.stringify(this.stockInItem));
              _stockInItem.productUnits = [productUnit];
              _stockInItem.productCode = productUnit.product.code;
              _stockInItem.productName = productUnit.product.name;
              _stockInItem.unitCost = productUnit.unitCost;
              _stockInItem.sellingPrice = productUnit.sellingPrice;
              _stockInItem.factorUnitName = productUnit.factorUnitName;
              _stockInItem.qty += 1;
              this.stockIn.stockInItems.push(_stockInItem);
            }
          }

          this.scanBarcode = "";
        })
        .catch(err => {
          console.log(err);
        });
    },

    removeStockInItem(index, stockInItemId) {
      if (stockInItemId) {
        // add delete stock in id
        if (!this.stockIn.deleteStockInItemIds) {
          this.stockIn.deleteStockInItemIds = [];
        }
        this.stockIn.deleteStockInItemIds.push(stockInItemId);
      }
      this.$delete(this.stockIn.stockInItems, index);
    },

    getStockInDetail(id) {
      stockInService
        .getStockInDetail(id)
        .then(res => {
          this.stockIn = res.data;
          this.createdDate = commonService.formatDate(
            new Date(this.stockIn.createdDateInMilliSeconds)
              .toISOString()
              .substr(0, 10),
            "YYYY-MM-DD"
          );
          this.updatedDate = commonService.formatDate(
            new Date(this.stockIn.updatedDateInMilliSeconds)
              .toISOString()
              .substr(0, 10),
            "YYYY-MM-DD"
          );
          this.status = this.stockIn.status;
          if (this.status == "FINISHED") {
            this.btnDisabled = true;
          }
          this.issueDate = commonService.millisecondToDate(
            this.stockIn.issueDateInMilliSeconds,
            "YYYY-MM-DD"
          );
          // deep copy
          this.oldStockIn = JSON.parse(JSON.stringify(res.data));
        })
        .catch(err => {
          console.log(err);
        });
    },

    onSave() {
      if (this.$refs.form.validate()) {
        this.saveLoading = true;
        //convert to millisecond
        this.stockIn.issueDateInMilliSeconds = commonService.convertToMilliseconds(
          this.issueDate
        );

        stockInService
          .saveStockIn(this.stockIn)
          .then(res => {
            if (res) {
              this.goBack();
            }
          })
          .catch(err => {
            console.log(err);
            if (err.response.data) {
              this.responseError = err.response.data.message;
            }
            this.saveLoading = false;
          });
      }
    },

    initPrice(factorUnitName, index) {
      let productUnit = commonService.search(
        "factorUnitName",
        factorUnitName,
        this.stockIn.stockInItems[index].productUnits
      );
      this.stockIn.stockInItems[index].unitCost = productUnit.unitCost;
      this.stockIn.stockInItems[index].sellingPrice = productUnit.sellingPrice;
    },

    clear() {
      this.$refs.form.resetValidation();
      if (!this.stockIn.id) {
        this.stockIn = new StockIn();
        this.addStockInItem();
      } else {
        this.stockIn = Object.assign({}, this.oldStockIn);
      }
    },

    getProductList() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      return productService
        .getProductList(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then(res => {
          if (res.data) {
            this.productList = res.data.productList;
            this.totalRows = res.data.totalElements;
          }
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },

    showProducts() {
      // Clean query params
      this.queryParams.code = "";
      this.queryParams.name = "";
      this.queryParams.brandName = "";
      this.queryParams.categoryName = "";
      this.queryParams.productGroupName = "";

      this.getProductList().then(
        (this.showProductListDialog = !this.showProductListDialog)
      );
    },
    showPurchaseOrder() {
      // Clean query params
      this.purchaseOrderQueryParams.fromIssueDate = commonService.formatDate(
        new Date(),
        "YYYY-MM-DD"
      );
      this.purchaseOrderQueryParams.toIssueDate = commonService.formatDate(
        new Date(),
        "YYYY-MM-DD"
      );
      this.purchaseOrderQueryParams.issueNo = "";
      this.purchaseOrderQueryParams.status = "";
      this.purchaseOrderQueryParams.currencyId = "";
      this.purchaseOrderQueryParams.warehouseId = "";

      this.getPurchaseOrderList().then(
        (this.showPurchaseOrderListDialog = !this.showPurchaseOrderListDialog)
      );
    },
    getPurchaseOrderList() {
      // Only 'FINISHED' state purchase order can link with Stock In
      this.purchaseOrderQueryParams.status = "FINISHED";

      this.showListLoading = true;
      let order = this.purchaseOrderPagination.descending ? "desc" : "asc";
      return purchaseOrderService
        .getPurchaseOrderList(
          this.purchaseOrderQueryParams,
          this.purchaseOrderPagination.page,
          this.purchaseOrderPagination.rowsPerPage,
          this.purchaseOrderPagination.sortBy + "," + order
        )
        .then(res => {
          if (res.data) {
            this.purchaseOrderList = res.data.data;
            this.purchaseOrderTotalRows = res.data.totalElements;
          }
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },

    setProduct(code, index) {
      let product = commonService.search("code", code, this.productList);
      this.stockIn.stockInItems[index].productCode = product.code;
      this.stockIn.stockInItems[index].productName = product.name;
      this.stockIn.stockInItems[index].factorUnitName = "";
      this.stockIn.stockInItems[index].productUnits = product.productUnits;
      this.stockIn.stockInItems[index].unitCost = 0;
      this.stockIn.stockInItems[index].sellingPrice = 0;
      this.stockIn.stockInItems[index].qty = 0;
    },
    prepareStockInItems(item) {
      var stockIn = this.stockIn;
      stockIn.poNo = item.issueNo;
      // Clear previous datas
      stockIn.stockInItems = [];

      let purchaseOrderItems = item.purchaseOrderItems;
      if (purchaseOrderItems) {
        purchaseOrderItems.forEach(item => {
          let stockInItem = {
            productCode: "",
            productName: "",
            factorUnitName: "",
            productUnits: "",
            unitCost: 0,
            sellingPrice: 0,
            qty: 0,
            remark: ""
          };
          stockInItem.productCode = item.productCode;
          stockInItem.productName = item.productName;
          stockInItem.factorUnitName = item.factorUnitName;
          stockInItem.productUnits = item.productUnits;
          stockInItem.unitCost = item.unitCost;
          stockInItem.sellingPrice = item.sellingPrice;
          stockInItem.qty = item.qty;
          stockInItem.remark = item.remark;
          stockIn.stockInItems.push(stockInItem);
        });
      }
    }
  }
};
</script>

